/**
 * Provides visual feedback for download buttons:
 * Shows loading spinner for 1 second and prevents multiple clicks
 *
 * Usage:
 *   Add data-animate-download attribute to any download button
 *   Add data-animate-download-dropdown to dropdown items
 */

import { onceEach } from "./once.js";

function animateDownloadButton(button, duration = 1000) {
  // Prevent multiple clicks during animation
  if (button.hasAttribute("data-animating")) {
    return;
  }

  button.setAttribute("data-animating", "true");

  // Add loading state and disable
  button.classList.add("is-loading");
  if (button.tagName === "BUTTON") {
    button.setAttribute("disabled", "true");
  }

  // Reset to original state after duration
  setTimeout(() => {
    button.classList.remove("is-loading");
    if (button.tagName === "BUTTON") {
      button.removeAttribute("disabled");
    }
    button.removeAttribute("data-animating");
  }, duration);
}

function initializeDownloadAnimations() {
  const buttons = document.querySelectorAll("[data-animate-download]");

  onceEach(buttons, "animate-download", (button) => {
    button.addEventListener("click", (e) => {
      // Prevent multiple downloads during animation
      if (button.hasAttribute("data-animating")) {
        e.preventDefault();
        return;
      }

      animateDownloadButton(button);
    });
  });
}

function initializeDropdownAnimations() {
  const dropdownItems = document.querySelectorAll("[data-animate-download-dropdown]");

  onceEach(dropdownItems, "animate-download-dropdown", (item) => {
    item.addEventListener("click", (e) => {
      // Find the parent dropdown and its trigger button
      const dropdown = item.closest(".dropdown");
      const triggerButton = dropdown?.querySelector(".dropdown-trigger button");

      if (!triggerButton) {
        return;
      }

      // Prevent multiple downloads during animation
      if (triggerButton.hasAttribute("data-animating")) {
        e.preventDefault();
        return;
      }

      animateDownloadButton(triggerButton);
    });
  });
}

document.addEventListener("DOMContentLoaded", () => {
  initializeDownloadAnimations();
  initializeDropdownAnimations();
});
